import React from 'react'
import roundUpCurrency from '../../utils/roundUpCurrency';

class ReusableAxisTick extends React.Component {

  render () {
    const {type, x, y, stroke, payload, periodsFormatter} = this.props;

    if (type == 'currency') { 
      return (
        <g transform={`translate(${x},${y})`}>
          <text x={0} y={0} dy={16} textAnchor="end" fill="#666">{`$${roundUpCurrency(payload.value)}`}</text>
        </g>
      );
    } else if (type == 'year' && payload.value != 0) {
      return (
        <g transform={`translate(${x},${y})`}>
          <text
            x={0}
            y={0}
            dy={16}
            textAnchor="end" fill="#666"
          >
            {periodsFormatter(payload.value)}
          </text>
        </g>
      );
    } else {
      return null
    }
  }
};

export default ReusableAxisTick;
